module.exports = __webpack_public_path__ + "static/media/step_002.f57138d2.jpeg";